(function () {
  'use strict';

  // Each slot has a label (shown/saved) plus a start time used for cutoff math.
  const TIME_SLOTS = {
    pickup: [
      { label: '10:00 AM - 11:00 AM', startHour: 10, startMinute: 0 },
      { label: '11:00 AM - 12:00 PM', startHour: 11, startMinute: 0 },
      { label: '12:00 PM - 1:00 PM', startHour: 12, startMinute: 0 },
      { label: '1:00 PM - 2:00 PM', startHour: 13, startMinute: 0 },
      { label: '2:00 PM - 3:00 PM', startHour: 14, startMinute: 0 },
      { label: '3:00 PM - 4:00 PM', startHour: 15, startMinute: 0 },
      { label: '4:00 PM - 5:00 PM', startHour: 16, startMinute: 0 },
      { label: '5:00 PM - 6:00 PM', startHour: 17, startMinute: 0 },
      { label: '6:00 PM - 7:00 PM', startHour: 18, startMinute: 0 },
      { label: '7:00 PM - 8:00 PM', startHour: 19, startMinute: 0 },
      
    ],
    normal: [
      // cutoff = must order before this time, ONLY when selected date is today
      { label: '10:00 AM - 12:30 PM', startHour: 10, startMinute: 0, cutoffHour: 9, cutoffMinute: 0 },
      { label: '12:30 PM - 3:00 PM', startHour: 12, startMinute: 30, cutoffHour: 11, cutoffMinute: 30 },
      { label: '3:00 PM - 5:30 PM', startHour: 15, startMinute: 0, cutoffHour: 14, cutoffMinute: 0 },
      { label: '5:30 PM - 8:00 PM', startHour: 17, startMinute: 30, cutoffHour: 16, cutoffMinute: 30 }
    ],
    express: [
      // requires at least EXPRESS_LEAD_HOURS lead time from now to slot start
      { label: '10:30 AM - 11:30 AM', startHour: 10, startMinute: 30 },
      { label: '11:30 AM - 12:30 PM', startHour: 11, startMinute: 30 },
      { label: '12:30 PM - 1:30 PM', startHour: 12, startMinute: 30 },
      { label: '1:30 PM - 2:30 PM', startHour: 13, startMinute: 30 },
      { label: '2:30 PM - 3:30 PM', startHour: 14, startMinute: 30 },
      { label: '3:30 PM - 4:30 PM', startHour: 15, startMinute: 30 },
      { label: '4:30 PM - 5:30 PM', startHour: 16, startMinute: 30 }
    ]
  };

  const EXPRESS_LEAD_HOURS = 1;
  const PICKUP_LEAD_HOURS = 1;
  const DISABLED_DATES = ['2026-07-18'];
  const MAX_DATE_SEARCH_DAYS = 60; // safety bound for the forward search

function shouldDisableToday() {
  const today = new Date();
  const key = getSlotKey(currentState());

  return getAvailableSlots(key, today).length === 0;
}

document.addEventListener('DOMContentLoaded', init);

function forceDefaultDelivery() {
    const root = document.getElementById('ss-delivery');
    if (!root) return;

    const normalInput = root.querySelector('input[name="ss_type"][value="normal"]');
    if (normalInput) normalInput.checked = true;

    const deliveryInput = root.querySelector('input[name="ss_method"][value="delivery"]');
    if (deliveryInput) deliveryInput.checked = true;
  }

window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      forceDefaultDelivery();

      const root = document.getElementById('ss-delivery');
      if (root) root.dataset.ssInitialized = 'false';

      setTimeout(function () {
        forceDefaultDelivery();
        init();
      }, 0);
    }
  });

  // Easify Product Options (or similar) restores previously-selected
  // option values shortly after load, which can re-check our Express
  // radio behind our back. Reassert our default a few times after load
  // to win against that late restoration.
  function guardAgainstThirdPartyRestore() {
    let attempts = 0;
    const maxAttempts = 20; // ~2 seconds total
    const interval = setInterval(function () {
      attempts++;
      const root = document.getElementById('ss-delivery');
      if (root) {
        const expressInput = root.querySelector('input[name="ss_type"][value="express"]');
        if (expressInput && expressInput.checked && root.dataset.ssUserSelectedExpress !== 'true') {
          expressInput.checked = false;
          const normalInput = root.querySelector('input[name="ss_type"][value="normal"]');
          if (normalInput) normalInput.checked = true;
          normalInput?.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 100);
  }

  document.addEventListener('DOMContentLoaded', guardAgainstThirdPartyRestore);

  async function init() {
    const root = document.getElementById('ss-delivery');
    if (!root) return;

   if (root.dataset.ssInitialized === 'true') {
      return;
    }
    root.dataset.ssInitialized = 'true';
    root.dataset.ssUserSelectedExpress = 'false';

    const methodInputs = root.querySelectorAll('input[name="ss_method"]');
    const typeInputs = root.querySelectorAll('input[name="ss_type"]');
    const typeSection = root.querySelector('#ss-type-section');
    const dateInput = root.querySelector('#ss-date');
    const timeSelect = root.querySelector('#ss-time');
    const summary = root.querySelector('#ss-summary');
    const dateError = root.querySelector('#ss-date-error');
    const timeError = root.querySelector('#ss-time-error');
    const customerPhoneInput = root.querySelector('#ss-customer-phone');
    // const recipientNameInput = root.querySelector('#ss-recipient-name');
    // const recipientPhoneInput = root.querySelector('#ss-recipient-phone');

    const expressVariantId = parseInt(root.dataset.expressVariantId, 10);

    // ---- Date parsing / formatting helpers (input is displayed/stored as d/m/Y) ----
    function parsessDate(value) {
      if (!value) return null;
      const [day, month, year] = value.split('/').map(Number);
      if (!day || !month || !year) return null;
      return new Date(year, month - 1, day);
    }

    function isSameCalendarDate(a, b) {
      return (
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
      );
    }

    function addDays(date, days) {
      const d = new Date(date);
      d.setDate(d.getDate() + days);
      return d;
    }

    function formatIsoDate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    }

    function formatssDate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${day}/${m}/${y}`;
    }

    flatpickr(dateInput, {
      minDate: 'today',
      defaultDate: 'today',
      dateFormat: 'd/m/Y',
      altInput: false,
      disableMobile: true,
      disable: [
        ...DISABLED_DATES,
        function (date) {
          return (
            isSameCalendarDate(date, new Date()) &&
            getAvailableSlots(getSlotKey(currentState()), date).length === 0
          );
        }
      ],
      onChange: function () {
        renderTimeOptions();
        updateCheckoutButtonState();
        if (dateError) dateError.hidden = true;
      }
    });

    function getChecked(inputs) {
      return Array.from(inputs).find((i) => i.checked)?.value;
    }

    function currentState() {
      return {
        method: getChecked(methodInputs), // delivery | pickup
        type: getChecked(typeInputs) // normal | express
      };
    }

    function getSlotKey({ method, type }) {
      return method === 'pickup' ? 'pickup' : type;
    }

   // ---- Cutoff / lead-time filtering ----
    function getAvailableSlots(key, selectedDate) {
      const slots = TIME_SLOTS[key] || [];
      if (!selectedDate) return slots;

      const now = new Date();
      const isToday = isSameCalendarDate(selectedDate, now);

      return slots.filter((slot) => {
        const slotStart = new Date(selectedDate);
        slotStart.setHours(slot.startHour, slot.startMinute, 0, 0);

        if (key === 'express') {
          const diffHours = (slotStart - now) / (1000 * 60 * 60);
          return diffHours >= EXPRESS_LEAD_HOURS;
        }

        if (key === 'pickup') {
          const diffHours = (slotStart - now) / (1000 * 60 * 60);
          return diffHours >= PICKUP_LEAD_HOURS;
        }

        if (key === 'normal') {
          if (!isToday) return true;
          if (slot.cutoffHour == null) return true;
          const cutoff = new Date(selectedDate);
          cutoff.setHours(slot.cutoffHour, slot.cutoffMinute, 0, 0);
          return now < cutoff;
        }

        return true;
      });
    }

    function findNextAvailableDate(key, fromDate) {
      const candidate = new Date(fromDate);
      candidate.setHours(0, 0, 0, 0);

      for (let i = 0; i <= MAX_DATE_SEARCH_DAYS; i++) {
        if (
          !DISABLED_DATES.includes(formatIsoDate(candidate)) &&
          getAvailableSlots(key, candidate).length > 0
        ) {
          return candidate;
        }
        candidate.setDate(candidate.getDate() + 1);
      }
      return null; // nothing found in the window — caller falls back to the empty-state message
    }

    function renderTimeOptions() {
      const key = getSlotKey(currentState());
      let selectedDate = parsessDate(dateInput.value);
      let slots = getAvailableSlots(key, selectedDate);

      if (slots.length === 0) {
        const searchFrom = selectedDate ? addDays(selectedDate, 1) : new Date();
        const nextDate = findNextAvailableDate(key, searchFrom);

        if (nextDate) {
          const fp = dateInput._flatpickr;
          if (fp) {
            fp.setDate(nextDate, false); // update value, don't re-fire onChange (avoids recursion)
          } else {
            dateInput.value = formatssDate(nextDate);
          }
          selectedDate = nextDate;
          slots = getAvailableSlots(key, selectedDate);
          if (dateError) dateError.hidden = true;
        }
      }

      if (slots.length === 0) {
        timeSelect.innerHTML = `<option value="" disabled selected>No time slots available for this date</option>`;
        return;
      }

      timeSelect.innerHTML =
        `<option value="" disabled selected>Select a time slot</option>` +
        slots.map((slot) => `<option value="${slot.label}">${slot.label}</option>`).join('');
    }

    function isExpressSelected() {
      const state = currentState();
      return state.method === 'delivery' && state.type === 'express';
    }

    function isFormValid() {
      const state = currentState();
      return !!state.method && !!dateInput.value && !!timeSelect.value && customerPhoneInput.value;
    }

    function updateCheckoutButtonState() {
      const checkoutBtn = document.getElementById('checkout');

      if (!checkoutBtn) return;
      checkoutBtn.disabled = !isFormValid();
    }

    function showFieldErrors() {
      if (dateError) dateError.hidden = !!dateInput.value;
      if (timeError) timeError.hidden = !!timeSelect.value;
    }

    function clearFieldErrors() {
      if (dateError) dateError.hidden = true;
      if (timeError) timeError.hidden = true;
    }

    function render() {
      const state = currentState();
      typeSection.hidden = state.method === 'pickup';
      renderTimeOptions();
      summary.hidden = !isExpressSelected();
      updateCheckoutButtonState();
    }
methodInputs.forEach((input) => input.addEventListener('change', render));
    typeInputs.forEach((input) => input.addEventListener('change', function () {
      root.dataset.ssUserSelectedExpress = (getChecked(typeInputs) === 'express') ? 'true' : 'false';
      render();
    }));

    timeSelect.addEventListener('change', function () {
      updateCheckoutButtonState();
      if (timeError) timeError.hidden = true;
    });

    customerPhoneInput.addEventListener('input', function () {
      updateCheckoutButtonState();

      if (customerPhoneInput.value) {
        customerPhoneInput.classList.remove('ss-input-error');
      }
    });

  render();

    console.log('INIT: about to sync, current isExpressSelected:', isExpressSelected(), 'radio express checked:', root.querySelector('input[name="ss_type"][value="express"]')?.checked);

    root.addEventListener('change', function(e) {
      console.log('RADIO CHANGED by something:', e.target.name, e.target.value, e.target.checked);
    }, true);

    const expressRadioEl = root.querySelector('input[name="ss_type"][value="express"]');
    if (expressRadioEl) {
      let lastChecked = expressRadioEl.checked;
      setInterval(function() {
        if (expressRadioEl.checked !== lastChecked) {
          console.log('EXPRESS RADIO FLIPPED (not via change event):', expressRadioEl.checked, new Error().stack);
          lastChecked = expressRadioEl.checked;
        }
      }, 50);
    }

    try {
      const removedStaleExpress = await syncExpressLineItem();
      console.log('INIT: sync done, removedStaleExpress:', removedStaleExpress);
      if (removedStaleExpress) {
        console.log('INIT: reloading now');
        window.location.reload();
        return;
      }
    } catch (err) {
      console.error('ss-delivery: initial sync failed', err);
    }

   

    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) {
      const observer = new MutationObserver(() => updateCheckoutButtonState());
      observer.observe(cartFooter, { childList: true, subtree: true });
    }

    // ---- Hook into the existing cart checkout button ----
    document.addEventListener('click', function (e) {
      const checkoutBtn = e.target.closest('#checkout');
      if (!checkoutBtn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      handleCheckoutClick(e, checkoutBtn);
    }, true);

    async function handleCheckoutClick(e, checkoutBtn) {
      e.preventDefault();
      e.stopPropagation();

      if (!isFormValid()) {
        showFieldErrors();
        return;
      }

      clearFieldErrors();
      checkoutBtn.disabled = true;
      const originalText = checkoutBtn.textContent;

      try {
        await syncExpressLineItem();
        await saveDeliveryAttributes();
        window.location.href = '/checkout';
      } catch (err) {
        console.error('ss-delivery checkout error:', err);
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = originalText;
        alert(err.message || 'Something went wrong. Please try again.');
      }
    }

    function swapSection(id, html) {
      const target = document.getElementById(id);
      if (!target || !html) return;
      target.outerHTML = html;
    }

    // async function removeExpressFeeOnInit() {
    //   if (!expressVariantId) return;

    //   const cart = await fetch('/cart.js', { keepalive: true }).then((r) => r.json());
    //   const existing = cart.items.find((item) => item.variant_id === expressVariantId);
    //   if (!existing) return;

    //   const res = await fetch('/cart/change.js', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     keepalive: true,
    //     body: JSON.stringify({
    //       id: existing.key,
    //       quantity: 0,
    //       sections: ['main-cart-items', 'main-cart-footer'],
    //       sections_url: '/cart'
    //     })
    //   });

    //   if (!res.ok) return;

    //   const data = await res.json();
    //   if (data.sections) {
    //     swapSection('main-cart-items', data.sections['main-cart-items']);
    //     swapSection('main-cart-footer', data.sections['main-cart-footer']);
    //   }
    //   document.dispatchEvent(new CustomEvent('cart:refresh'));
    // }

    async function syncExpressLineItem() {
      if (!expressVariantId) return;

      const cart = await fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' }).then((r) => r.json());

      const existing = cart.items.find(
        (i) => i.variant_id === expressVariantId
      );

      const shouldHaveExpress = isExpressSelected();

      console.log('syncExpressLineItem:', {
        expressVariantId,
        existingQty: existing ? existing.quantity : 0,
        shouldHaveExpress,
        currentState: currentState()
      });

      // Add express fee
      if (shouldHaveExpress && !existing) {
       const res = await fetch('/cart/add.js', {
          method: 'POST',
          cache: 'no-store',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: expressVariantId,
                quantity: 1
              }
            ]
          })
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(
            data.description ||
            data.message ||
            'Could not add Express Delivery fee.'
          );
        }
      }

      // Remove express fee
      else if (!shouldHaveExpress && existing) {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          cache: 'no-store',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: existing.key,
            quantity: 0
          })
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(
            data.description ||
            data.message ||
            'Could not remove Express Delivery fee.'
          );
        }

        return true;
      }

      return false;
    }

    async function saveDeliveryAttributes() {
      const state = currentState();

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Delivery Method': state.method === 'pickup' ? 'Pickup' : 'Local Delivery',
            'Delivery Type': state.method === 'pickup' ? '-' : (state.type === 'express' ? 'Express' : 'Standard'),
            'Delivery Date': dateInput.value,
            'Delivery Time': timeSelect.value,
            'Your Contact Number': customerPhoneInput.value
            // 'Recipient Name': recipientNameInput.value,
            // 'Recipient Number': recipientPhoneInput.value
          }
        })
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.description || data.message || 'Could not save delivery details.');
      }
    }
  }
})();